module.exports = __webpack_public_path__ + "37d248a94f483e83c56c7f9a9d670c40.pdf";